export default "__VITE_ASSET__KWxVO2QC__"